
import Vue from 'vue'


export default Vue.extend({
  name: 'RequestAccountDeleteDialog',
  props: {
    value: {
      type: Boolean,
    },
  },
  data: () => ({
    message: ''
  }),
  mounted() {
    this.$api.get('/contents/static/deleteRequestMessage')
      .then((result) => {
        this.message = result.data.message
      })
  },
  methods: {
    removeMyAccount: function () {
      this.$api
        .delete('/me')
        .then(() => {
          this.$emit('input', false);
          this.$store.dispatch(
            'alert/warning',
            "Your account removal request has been submitted."
          )
        })
        .catch(() => {
          this.$store.dispatch(
            'alert/error',
            "Problems with user's account delete."
          )
        })
    },
  }
})
